// extracted by mini-css-extract-plugin
export default {"searchField":"Search_searchField__yeySC","formControl":"Search_formControl__eskDy","icono":"Search_icono__L6s9K"};